import React from 'react'
// import Tooltip from 'react-tooltip'
import { connect } from 'react-redux'
import Toggle from 'react-toggle'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import UpdateEsim from '../Containers/Esim/UpdateEsim'
import EsimCountry from '../Containers/Esim/EsimCountry'
import UpdateEsimImage from '../Containers/Esim/UpdateEsimImage'
import EsimActions from '../Redux/EsimRedux'
import FormatMoney from '../Utils/FormatMoney'
import UpdateVarianEsim from '../Containers/Esim/UpdateVarianEsim'
// import PriceComparison from '../../Containers/Markup/PriceComparison'
// import ComparisonDetails from '../../Containers/Markup/ComparisonDetails'

class EsimPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {},
      variant: {},
      filter: {
        sort: 'title',
        page: 1,
        q: '',
      },
    }
  }

  componentDidMount = () => {
    this.props.getAllEsims(this.state.filter)
  }

  _fetchEsims = (event) => {
    event.preventDefault()

    this.props.getAllEsims(this.state.filter)
  }

  _filterChange = (event, field) => {
    let filter = { ...this.state.filter }
    filter[field] = event.target.value
    if (field === 'order_status') {
      filter['status'] = ''
    }
    this.setState({ filter })
  }

  _toggleModal = (modalId = null) => {
    if (!modalId) this.props.getAllEsims(this.state.filter)
    this.setState({ showModal: modalId })
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _selectItemVariant = (item, variant, action) => {
    this.setState({ detail: item, variant: variant })
    this._toggleModal(action)
  }

  _toggleField = (item, field, event) => {
    let form = {
      image_file: item.image_file,
      description: item.description,
      is_featured: item.is_featured,
      is_active: item.is_active
    }

    form[field] = event.target.checked

    this.props.updateEsim({id: item.id, form})
    setTimeout(() => {
      this.props.getAllEsims(this.state.filter)
    }, 750)
  }

  _toggleVariantField = (item, variant, event) => {
    let formData = {
      id: item.id,
      variant_id: variant.id,
      form: {
        availability: event.target.checked
      }
    }


    this.props.updateEsimVariant(formData)
    setTimeout(() => {
      this.props.getAllEsims(this.state.filter)
    }, 750)
  }

  _changePage = (page) => {
    let filter = {
      ...this.state.filter,
      page
    }
    this.setState({ filter })
    this.props.getAllEsims(filter)
  }

  render () {
    const { esims } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3'>
            <h3 className='title mr-auto'>
              eSIM Product
              {
                (esims.fetching || esims.processing) &&
                <div className='badge badge-info ml-2'>{esims.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <form className='form-inline' onSubmit={(event) => this._fetchEsims(event)}>
            <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Search</label>
                <input style={{ width: '250px' }} type='text' placeholder='Name / Desc' className='form-control' value={this.state.filter.q} onChange={(event) => this._filterChange(event, 'q')} />
              </div>
              <div className='form-group mr-2 mb-2'>
                <button type='submit' className='btn btn-primary'>Apply Filter</button>
              </div>
            </form>
          </div>
        </header>
        <section className='section' style={{ width: '100%' }}>
          <div className='card'>
            {
              !(esims.fetching || esims.processing) && esims.err &&
              <div className='alert alert-danger'>{esims.err}</div>
            }
            <div className='card-block'>
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Featured</th>
                    <th>Active</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {!esims.data || !esims.data.data 
                    ? <tr>
                        <td colSpan='5' className='text-center'>- NO DATA -</td>
                      </tr>
                    : esims.data.data.map((item, ) => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>
                          <img src={item.image_url} width={100} alt={item.name} />
                        </td>
                        <td>
                          <Toggle checked={item.is_featured} onChange={event => this._toggleField(item, "is_featured", event)} disabled={esims.fetching || esims.processing} />
                        </td>
                        <td>
                          <Toggle checked={item.is_active} onChange={event => this._toggleField(item, "is_active", event)} disabled={esims.fetching || esims.processing} />
                        </td>
                        <td>
                          <div className='d-flex mb-2'>
                            <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'update')}>
                              <i className='fa fa-edit' /> Edit Content
                            </button>
                            <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'esim-countries')}>
                              <i className='fa fa-globe' /> Country
                            </button>
                            <button className='btn btn-primary' onClick={() => this._selectItem(item, 'esim-image')}>
                              <i className='fa fa-image' /> Images
                            </button>
                          </div>

                          <table className='table table-bordered table-striped'>
                            <thead>
                              <tr>
                                <th>Data Size</th>
                                <th>Days</th>
                                <th>Base Price</th>
                                <th>Price</th>
                                <th>Availability</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.variants 
                                ? item.variants.length !== 0 
                                  ?  item.variants.map((variant) => (
                                      <tr key={variant.id}>
                                          <td>{variant.data_size}</td>
                                          <td>{variant.day || 0} day</td>
                                          <td>IDR {FormatMoney(variant.base_price)}</td>
                                          <td>IDR {FormatMoney(variant.price)}</td>
                                          <td>
                                            <Toggle 
                                              checked={variant.availability} 
                                              onChange={event => this._toggleVariantField(item, variant, event)} 
                                              disabled={esims.fetching || esims.processing} 
                                            />
                                          </td>
                                          <td>
                                            <button className='btn btn-sm btn-info' onClick={() => this._selectItemVariant(item, variant, 'update-variant')}>
                                              <i className='fa fa-edit'></i>
                                            </button>
                                          </td>
                                        </tr>
                                    ))
                                  : <tr>
                                      <td colSpan={4}>- No Data -</td>
                                    </tr>
                                : <tr>
                                    <td colSpan={3}>- No Data -</td>
                                  </tr>
                              }
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
              <section className='text-center'>
                {
                  (esims.data && esims.data.total > 10) &&
                  <Pagination
                    innerClass='pagination'
                    itemClass='page-item'
                    linkClass='page-link'
                    activePage={esims.data.page || this.state.filter.page}
                    itemsCountPerPage={10}
                    totalItemsCount={esims.data.total}
                    pageRangeDisplayed={5}
                    onChange={this._changePage}
                  />
                }
              </section>
            </div>
          </div>
        </section>
        
        {/* Modal Update */}
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateEsim closeModal={() => this._toggleModal()} detail={this.state.detail} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-variant'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateVarianEsim closeModal={() => this._toggleModal()} detail={this.state.detail} variant={this.state.variant} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'esim-countries'} onClose={this._toggleModal} closeOnOverlayClick>
          <EsimCountry closeModal={() => this._toggleModal()} detail={this.state.detail} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'esim-image'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateEsimImage closeModal={() => this._toggleModal()} detail={this.state.detail} />
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  esims: state.esims,
})

const dispatchToProps = (dispatch) => ({
  getAllEsims: (filter) => dispatch(EsimActions.getAllEsimsRequest(filter)),
  updateEsim: (data) => dispatch(EsimActions.esimUpdateRequest(data)),
  updateEsimVariant: (data) => dispatch(EsimActions.esimUpdateVariantRequest(data))
})

export default connect(stateToProps, dispatchToProps)(EsimPage)



// WEBPACK FOOTER //
// ./src/Pages/EsimPage.js